import React from "react";
import { Link } from "react-router-dom";
import logo from "../../logo.png";


const NavHome = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light sticky-top bg-body-tertiary">
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <Link className="navbar-brand" to="#">
          <img
            src={logo}
            style={{ paddingBottom: "10px" }}
            alt="Logo"
            width="30"
            height="40"
            className="d-inline-block align-item-center"
          />
          <strong className="ps-2">Cassava Super</strong>
        </Link>
        <ul
          className="nav justify-content-end navbar-nav collapse navbar-collapse"
          id="navbarTogglerDemo03"
        >
          <li className="nav-item">
            <a className="nav-link underline" to="#home-dash">
              HOME
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link underline" href="#about-us">
              ABOUT
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link underline" href="#stakeholder">
              STAKEHOLDER
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link underline" href="#contact-us">
              CONTACT
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link underline" href="/traceability">
              TRACEABILITY
            </a>
          </li>
          <li className="nav-item">
            <Link to="/login" className="nav-link underline">
              LOGIN
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavHome;
